import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-header__sortable-content"
}
const _hoisted_2 = { class: "table-header__text" }
const _hoisted_3 = {
  key: 2,
  class: "table-header__text"
}

import { i18n } from '@/i18n';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import TableHead from '../TableHead.vue';
import ArrowIcon from '../ArrowIcon.vue';
import { TrashBinTableContentViewModel } from './trashBinTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrashBinTableHead',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    forecastStartYearMonth: { default: undefined }
  },
  emits: ["onClickSort", "onMousedownResizer", "onCheckboxSelected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const TrashBinTableContentVM = new TrashBinTableContentViewModel();

const emits = __emit;

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  const _component_RowCheckBox = _resolveComponent("RowCheckBox")!

  return (_openBlock(), _createBlock(TableHead, {
    class: _normalizeClass([_unref(TrashBinTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : '']),
    style: _normalizeStyle({
      left: _unref(TrashBinTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    index: _ctx.headerIndex,
    resizable: 
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      _ctx.header.isVariableWidth && !_unref(TrashBinTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex)
    ,
    onOnMousedownResizer: _cache[2] || (_cache[2] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
  }, {
    default: _withCtx(() => [
      (_ctx.header.key === 'trashBinChoice')
        ? (_openBlock(), _createBlock(_component_RowCheckBox, {
            key: 0,
            "is-checked": _ctx.isAllSelected,
            class: "md-primary all-check-button",
            onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCheckboxSelected', '', true)))
          }, null, 8, ["is-checked"]))
        : (_ctx.header.sortOption.isSortable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(_unref(TrashBinTableContentVM).getHeaderText(_ctx.header.key, _ctx.forecastStartYearMonth) ?? '')), 1),
              _createVNode(ArrowIcon, {
                asc: _ctx.header.sortOption.isAsc,
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc)))
              }, null, 8, ["asc"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)(_unref(TrashBinTableContentVM).getHeaderText(_ctx.header.key, _ctx.forecastStartYearMonth) ?? '')), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "index", "resizable"]))
}
}

})